<template>
  <div class="container">
    <b-row>
      <div class="col-6">
        <div class="ld-card-header">
          <img :src="userData.logo" v-if="userData.logo" style="max-height: 50px;" />
          <img src="@/assets/images/logo-interra-2.svg" alt="interra logo" class="logo-img" style="max-height: 50px;">
        </div>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-end noPrint">
        <div>
          <button class="btn btn-outline-primary btn-xs " @click="$emit('print')" v-b-tooltip.hover :title="$gettext('print')">
            <b-icon icon="file-earmark-text" />
          </button>
          <button class="btn btn-outline-danger btn-xs mx-2" @click="download()" v-b-tooltip.hover :title="$gettext('PDF')">
            <b-icon icon="download" />
          </button>
          <button class="btn btn-outline-info btn-xs " @click="$emit('closeModal')" v-b-tooltip.hover :title="$gettext('Close')">
            <b-icon icon="x" />
          </button>
        </div>
      </div>
      <b-col><hr></b-col>
    </b-row>
  </div>
</template>

<script>
import authMixin from 'b2b-common/mixins/auth'
import axios from 'b2b-common/vue-config/axios'

export default {
  name: 'modalHeader',
  mixins: [authMixin],
  methods: {
    cleanupDOM () {
      // remove from DOM any elements that have a class of "removeFromPrint"
      const elements = document.getElementsByClassName('removeFromPrint')
      while (elements.length > 0) elements[0].remove()

      // find any DOM elements that have a class of "print-only" and remove the class
      const elements2 = document.getElementsByClassName('print-only')
      for (let i = 0; i < elements2.length; i++) {
        elements2[i].classList.remove('print-only')
      }

      // find any images with a class of 'data-url-replace'
      const images = document.getElementsByClassName('data-url-replace')
      for (let i = 0; i < images.length; i++) {
        // retrieve the source of the image
        const url = images[i].src
        if (url.startsWith('data:')) continue
        // replace the source with the data by retrieving the data from the server
        // and replacing the source with the data
        axios.get(url, { responseType: 'blob' }).then(response => {
          const reader = new FileReader()
          reader.readAsDataURL(response.data)
          reader.onloadend = () => {
            images[i].src = reader.result
          }
        })
      }
    },
    download () {
      this.cleanupDOM()
      this.$emit('download')
    }
  }
}
</script>
